var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-menu-vue"},[_c('Menu',{ref:"menu",attrs:{"accordion":true,"datas":_vm.datas,"className":"h-menu-white"},on:{"click":_vm.trigger}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }